import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NotificationConfig, NotificationRef } from '@box-core/components';
import { InfoNotificationWidgetData } from './info-notification-wrapper.types';
import { getCircumference } from '@box-core/components/notification/notification.utils';

@Component({
  selector: 'info-notification-wrapper',
  templateUrl: './info-notification-wrapper.component.html',
  styleUrls: ['./info-notification-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoNotificationWrapperComponent implements OnInit {
  public matIcon: string;
  public title: string;
  public message: string;
  public closeButton: boolean;
  public autoClose: boolean = true;
  private shouldAnimate = true;

  private readonly radius = 14;
  private readonly duration = 5000;
  private circumference = getCircumference(this.radius);

  constructor(
    private notificationConfig: NotificationConfig,
    private notificationRef: NotificationRef
  ) {}

  ngOnInit(): void {
    const data = this.notificationConfig.data as InfoNotificationWidgetData;
    this.matIcon = data.matIcon ?? 'info';
    this.title = data.title;
    this.message = data.message;
    this.closeButton = data.closeButton;
    this.autoClose = data.autoClose;
    this.shouldAnimate = this.autoClose;
  }

  ngAfterViewInit(): void {
    if (this.shouldAnimate) this.animateCircle();
  }

  public animateCircle() {
    const circle = document.querySelector('.progress-ring-circle') as SVGCircleElement | null;
    if (!circle) return;

    circle.style.strokeDasharray = `${this.circumference} ${this.circumference}`;
    circle.style.strokeDashoffset = '0';
    const start = performance.now();

    const step = (timestamp: number) => {
      const elapsed = timestamp - start;
      const progress = Math.min(elapsed / this.duration, 1);
      const offset = this.circumference * progress;
      circle.style.strokeDashoffset = offset.toString();

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        this.onClose();
      }
    };

    requestAnimationFrame(step);
  }

  public onClose(): void {
    this.notificationRef.dismiss();
  }

  public onClick(): void {
    if (this.closeButton) return;
    this.onClose();
  }
}
